import { render } from "./AddMaster.vue?vue&type=template&id=38cb89a6"
import script from "./AddMaster.vue?vue&type=script&lang=js"
export * from "./AddMaster.vue?vue&type=script&lang=js"

import "./AddMaster.vue?vue&type=style&index=0&id=38cb89a6&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__